var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-app",attrs:{"id":"app"}},[_c('PageHeader'),_c('main',{staticClass:"page-main"},[_c('PageTitle'),_c('router-view',{attrs:{"users-fetch":_vm.getUsers,"users-error":_vm.usersError},on:{"update-users":_vm.updateUsers}})],1),(_vm.isLoading)?_c('UILoader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }